import React, { useEffect,useState } from "react";
import Header from "./Header/Header";
import "./AnalyticsScreen.scss";
import BasicReports from "./BasicReports/BasicReports";
import { fetchBasicAnalyticsRequest } from "../../../redux/exam_analytics/analyticsSlice";
import { useDispatch, useSelector } from "react-redux";
import { ClipLoader } from "react-spinners";
import { useLocation,useHistory  } from "react-router-dom";

const AnalyticsScreen = () => {
  const dispatch = useDispatch();
const history = useHistory();
const { testDetails } = useSelector((state) => state.examSlice);
const source = testDetails?.source;
  const [attempt, setAttempt] = useState(0);
  const [isAttemptInitialized, setIsAttemptInitialized] = useState(false);

  const { basicAnalytics, loading, error } = useSelector(
    (s) => s.analyticsSlice
  );
const location = useLocation();
useEffect(() => {
  const routePaperType = location.state?.paper_type;
  const routeSetId = location.state?.set_id;
  const routePaperId = location.state?.paper_id;
  const routePlannerTestId = location.state?.planner_test_id;

  if (routeSetId) {
    dispatch(
      fetchBasicAnalyticsRequest({
        paper_type: routePaperType,
        set_id: routeSetId,
      })
    );
    return;
  }

  if (routePaperId) {
    dispatch(
      fetchBasicAnalyticsRequest({
        paper_type: routePaperType,
        paper_id: routePaperId,
        planner_test_id: routePlannerTestId,
      })
    );
    return;
  }

  dispatch(fetchBasicAnalyticsRequest({}));
}, [
  dispatch,
  location.state?.paper_type,
  location.state?.set_id,
  location.state?.paper_id,
  location.state?.planner_test_id,
]);

const apiData = basicAnalytics?.data;
useEffect(() => {
  if (apiData?.selected_attempt === undefined || isAttemptInitialized) return;

  const apiAttemptCount = Number(apiData.selected_attempt);
  const attemptsList = apiData?.attempts || [];

  // Backend selected_attempt is attempt_count (1-based), while dropdown uses attempt id.
  const byTitle = attemptsList.find(
    (item) => Number(item?.title?.match(/\d+/)?.[0]) === apiAttemptCount
  );
  const byId = attemptsList.find((item) => Number(item?.id) === apiAttemptCount);
  const byIndex = attemptsList[apiAttemptCount - 1];

  const resolvedAttemptId = Number(
    byTitle?.id ?? byId?.id ?? byIndex?.id ?? attemptsList[0]?.id ?? 0
  );

  setAttempt(resolvedAttemptId);
  setIsAttemptInitialized(true);
}, [apiData, isAttemptInitialized]);

useEffect(() => {
  if (!apiData?.attempts?.length) {
    setIsAttemptInitialized(false);
  }
}, [apiData?.attempts]);
const isScoreReady =
  apiData &&
  apiData.user_marks !== null &&
  apiData.total_marks !== null;

const handleAttemptChange = (nextAttempt) => {
  if (nextAttempt === attempt) return;

  setAttempt(nextAttempt);

  const matchedAttempt = apiData?.attempts?.find((a) => a.id === nextAttempt);
  const titleCount = Number(matchedAttempt?.title?.match(/\d+/)?.[0]);
  const resolvedAttemptCount = Number.isFinite(titleCount)
    ? titleCount
    : nextAttempt + 1;

  const payload = {
    attempt_count: resolvedAttemptCount,
  };

  // When available, pass explicit route params; otherwise saga falls back to examSlice state.
  if (location.state?.set_id) {
    payload.paper_type = location.state.paper_type;
    payload.set_id = location.state.set_id;
  } else if (location.state?.paper_id) {
    payload.paper_type = location.state.paper_type;
    payload.paper_id = location.state.paper_id;
    payload.planner_test_id = location.state.planner_test_id;
  }

  dispatch(fetchBasicAnalyticsRequest(payload));
};


 
  if (loading?.basic) {
    return (
      <div className="analytics-loader">
        <ClipLoader color="#C61C26" size={55} />
      </div>
    );
  }

 
  if (error?.basic) {
    return (
      <div className="analytics-error">
        <p>Error: {error.basic}</p>
      </div>
    );
  }

  return (
    <div className="analytics-wrapper">
      {/* <Header paperName={apiData?.paper_name} />
      <BasicReports basicAnalytics={apiData} /> */}
      {/* <Header paperName={apiData?.paper_name} /> */}
      <Header
  paperName={apiData?.paper_name}
    attempts={apiData?.attempts}
  selectedAttempt={attempt}
  onAttemptChange={handleAttemptChange}
  onBack={() => {
    if (source === "topicwise") {
      history.push("/practice/topic-wise/pyqset");
    } else if (source === "yearwise") {
      history.push("/practice/paper-listing?type=Year Wise");
    } else {
      history.push("/practice/paper-listing");
    }
  }}
/>

{isScoreReady ? (
  <BasicReports basicAnalytics={apiData} />
) : (
  <div className="analytics-loader">
    <ClipLoader color="#C61C26" size={55} />
    <p>Preparing your scorecard...</p>
  </div>
)}

    </div>
  );
};

export default AnalyticsScreen;
